import DataSorter from "./DataSorter";

export default DataSorter;
